<template>
  <div class="fh-subform-content">
    <div class="subform-title">
      <div class="subform-title-name">
        <component :is="fieldIconMapping[modulesItem?.setting.fieldType]" style="margin-right: 8px" />
        <xl-label-text :value="modulesItem?.label || $t('子表单')" :row="1" />
        <jw-tooltip v-if="modulesItem?.toast">
          <icon-question-circle size="12" class="card-tooltip" />
          <template #content> {{ modulesItem.toast }} </template>
        </jw-tooltip>
        <qf-icon-required v-if="modulesItem.isRequired == 1 || modulesItem?.conditionsIsRequired == 1" />
      </div>
      <!--新建  -->
      <jw-button class="add-btn" type="text" size="small" v-if="isPermissionEdit && (from == 30 || type == 30 || (type == 40 && subformPermission?.canEdit == 1 && subformPermission?.detail?.add == 1))" @click="addDetail" :loading="data.loading"> <qfei-icon-add-two-outlined /> {{ $t('新建') }}</jw-button>
    </div>
    <!-- 全选状态 按钮 -->
    <template v-if="data.checkedAllShow">
      <div class="margin-b-10">
        <jw-button size="mini" style="margin-right: 10px" @click="toggleDeleteState">{{ $t('取消操作') }}</jw-button>
        <jw-popconfirm type="error" v-if="data.selectIds?.length > 0" @ok="batchDel">
          <jw-button size="mini" type="primary" status="danger">{{ $t('删除选中') }}</jw-button>
          <template #content>
            <p style="padding-bottom: 5px; font-weight: 600">
              {{ $t('你确定要删除所选记录吗？') }}
            </p>
            <p>
              {{ `${$t('你当前选中')} ${data.selectIds.length} ${$t('条记录，记录中的数据删除后将无法恢复！')}` }}
            </p>
          </template>
        </jw-popconfirm>
        <jw-button size="mini" v-else>{{ $t('删除选中') }}</jw-button>
      </div>
    </template>
    <fh-table :max-height="500" :row-class-name="getRowClass" from-page="35" :key="`${tableKey}-${dataList.length}`" :pagination="null" :loading="data.tableloading" bordered :data="dataList?.length ? dataList : [{}]" :columns="columns" :class="['sub-form-table', props.isFull ? `sub-form-table-2 sub-form-table2${modulesItem.id}` : `sub-form-table${modulesItem.id}`]">
      <template v-for="(c, index) in columns?.filter((gc) => gc?.title != 'operation')" :key="index" #[c?.title]>
        <div class="custom-table-th">
          <div class="hint" v-if="c?.isRequired">*</div>
          {{ c?.fieldName }}
          <jw-tooltip v-if="c?.toast">
            <icon-question-circle size="18" class="custom-table-th-toast" />
            <!-- 这是提示文本  -->
            <template #content> {{ c.toast }} </template>
          </jw-tooltip>
        </div>
      </template>
      <template #operation>
        <template v-if="data.checkedAllShow">
          <jw-checkbox :disabled="dataList?.length == 0" :model-value="checked" :indeterminate="indeterminate" @change="handleChangeAll"></jw-checkbox>
        </template>
        <template v-else>
          <!-- todo:事件使用css样式调整 -->
          <div @mouseenter="setHover(true)" @mouseleave="setHover(false)">
            <template v-if="!props.isFull"
            ><span style="color: var(--color-text-1)">{{ $t('序号') }}</span>
            </template>
            <div class="hover-box" :class="{ isOpacity: !isHover, isFull: props.isFull }">
              <icon-expand v-if="!props.isFull" size="16" class="cursor" @click="fullScreen" />
              <icon-shrink v-else size="16" class="cursor" @click="fullScreen" />
              <jw-popover :title="$t('批量删除')" v-if="isPermissionEdit && (from == 30 || type == 30 || (type == 40 && subformPermission?.canEdit == 1 && subformPermission?.detail?.remove == 1))">
                <icon-delete size="16" @click="toggleDeleteState" />
              </jw-popover>
            </div>
          </div>
        </template>
      </template>
      <template #operationCell="{ row, rowIndex }">
        <!-- 真实有数据展示，空状态下伪数据不显示 -->
        <template v-if="dataList?.length">
          <!-- 选中 -->
          <div v-if="data.checkedAllShow" class="checkedAll-content">
            <!-- 不可删除的才禁用 -->
            <!--<jw-checkbox-group :max="300" v-model="data.selectIds" :options="[rowIndex]" @change="handleChange">
              <template #label="{ data }">
                <span style="display: none">{{ data.value }}</span>
              </template>
            </jw-checkbox-group>-->
            <jw-checkbox :model-value="data.selectIds.includes(rowIndex)" @change="handleChange(rowIndex)"></jw-checkbox>
          </div>
          <template v-else>
            <div class="cell-index">
              {{ rowIndex + 1 }}
            </div>
            <div v-if="isPermissionEdit" class="sub-form-op-content">
              <icon-expand size="16" @click="toggleDrawerVisible(1, rowIndex)" />
              <!-- （从基础信息里的子表才会有此判断） -->
              <!-- 30：新增默认都可删除 -->
              <!-- 40：编辑的时候，只有历史数据且有删除权限 -->
              <template v-if="from == 30 || type == 30 || (type == 40 && dataList[rowIndex][0]?.detailId && subformPermission?.canEdit == 1 && subformPermission?.detail?.remove == 1) || dataList[rowIndex][0]?.remove">
                <jw-popconfirm type="error" @ok="del(rowIndex)" :popup-container="props.isFull ? `.sub-form-table2${modulesItem.id}` : props.isFull && from == 30 ? '.add-table-modal' : `.sub-form-table${modulesItem.id}`">
                  <icon-delete size="16" />
                  <template #content>
                    <p>{{ $t('该条记录存在数据，数据删除后将无法恢复，') }}</p>
                    <p>{{ $t('确定删除?') }}</p>
                  </template>
                </jw-popconfirm>
              </template>
              <!-- 有可插入权限且新增权限 -->
              <template v-if="from == 30 || type == 30 || (type == 40 && subformPermission?.canEdit == 1 && subformPermission?.detail?.insert == 1 && subformPermission?.detail?.add == 1)">
                <jw-popover trigger="click" :popup-container="props.isFull ? `.sub-form-table2${modulesItem.id}` : props.isFull && from == 30 ? '.add-table-modal' : `.sub-form-table${modulesItem.id}`">
                  <icon-more-vertical size="16" />
                  <template #content>
                    <div class="row-operation">
                      <jw-button class="margin-b-10" @click="batchOp(1, row, rowIndex)">{{ $t('复制到下一行') }}</jw-button>
                      <jw-button class="margin-b-10" @click="batchOp(2, row, rowIndex)">{{ $t('复制到最后一行') }}</jw-button>
                      <jw-button class="margin-b-10" @click="batchOp(3, row, rowIndex)" :loading="data.loading">{{ $t('向上插入行') }}</jw-button>
                      <jw-button class="margin-b-10" @click="batchOp(4, row, rowIndex)" :loading="data.loading">{{ $t('向下插入行') }}</jw-button>
                    </div>
                  </template>
                </jw-popover>
              </template>
              <!-- 没有可插入权限只有新增权限 -->
              <template v-if="from == 20 && type == 40 && subformPermission?.canEdit == 1 && !subformPermission?.detail?.insert && subformPermission?.detail?.add == 1">
                <jw-popover :title="$t('复制到最后一行')">
                  <icon-copy size="16" @click="batchOp(2, row, rowIndex)" />
                </jw-popover>
              </template>
            </div>
          </template>
        </template>
        <div v-else style="opacity: 0">-</div>
      </template>
      <template v-for="(c, index) in columns?.filter((gc) => gc?.title != 'operation')" #[c?.colKey]="{ rowIndex }" :key="c?.colKey">
        <!-- 真实有数据展示，空状态下伪数据不显示 -->
        <template v-if="dataList?.length">
          <fh-update-fields :modules="dataList[rowIndex]?.find((dl) => dl?.setting?.fieldKey == c?.colKey)" :formatData="dataList[rowIndex]" :from="35" :opType="1" :type="type" :rowIndex="rowIndex" @cb="updateModulesItem" :mainForm="mainForm" :popup-container="!props.isFull ? `.sub-form-table${modulesItem.id}` : props.isFull ? `.sub-form-table2${modulesItem.id}` : ''" />
          <span class="arco-form-item-message" v-if="dataList[rowIndex][index].setting?.fieldType == 11 && dataList[rowIndex][index]?.fieldValue && !tools.checkLink(dataList[rowIndex][index].fieldValue)"> 格式不正确,请以http:// 或 https:// 开头,且不能包含汉字! </span>
        </template>
      </template>
    </fh-table>
  </div>
  <jw-drawer unmountOnClose :width="500" hide-cancel :visible="drawerVisible" class="sub-form-table-modal" @cancel="toggleDrawerVisible(0)" :closable="false">
    <template #title>
      <div class="drawer-title">
        <span>子表单</span>
        <div class="op-div-content">
          <div class="op-number-content">
            <span class="switch-icon" @click="switchForm(1)"><icon-caret-left /></span>
            <span class="op-number-icon-content">
              <span> {{ data.recordIndex + 1 }}</span
              >/<span> {{ dataList?.length }}</span>
            </span>
            <span class="switch-icon" @click="switchForm(2)"><icon-caret-right /></span>
          </div>
          <span class="switch-icon" @click="toggleDrawerVisible(0)"><icon-shrink class="cursor" /></span>
        </div>
      </div>
    </template>
    <jw-form :model="{ subForm: dataList[data.recordIndex] }" :key="data.recordIndex" label-align="left" class="sub-form-drawer" ref="formRef" @submit="handleSubmit">
      <jw-row :gutter="24">
        <template v-for="(item, index) in dataList[data.recordIndex]" :key="item.id">
          <jw-col :span="24">
            <jw-form-item asterisk-position="end" :field="`subForm.${index}.fieldValue`" :class="['system-form-item', item?.setting?.fieldType === 12 ? 'relevancy-input' : '']" :rules="rules(item)" :validate-trigger="['blur', 'input', 'change']" :label-col-style="{ width: '120px' }" label-col-flex="auto" class="form-label-text">
              <template #label>
                <xl-label-text :value="item.setting?.fieldName" :row="1" />
                <jw-tooltip v-if="item?.toast">
                  <icon-question-circle size="18" />
                  <!-- 这是提示文本  -->
                  <template #content> {{ item.toast }} </template>
                </jw-tooltip>
              </template>
              <fh-update-fields :modules="item" :formatData="dataList[data.recordIndex]" :from="35" :type="type" @cb="updateDrawerModulesItem" :mainForm="mainForm" popup-container=".sub-form-drawer" />
            </jw-form-item>
            <!--附加说明 -->
            <div class="tips-detail" v-if="item?.memo">{{ item?.memo }}</div>
          </jw-col>
        </template>
      </jw-row>
    </jw-form>
    <template #footer>
      <jw-button type="primary" size="small" v-if="from == 30 || (from == 20 && type == 30) || (type == 40 && subformPermission?.canEdit == 1 && subformPermission?.detail?.add == 1)" @click="formRef.handleSubmit(1)">{{ $t('复制') }}</jw-button>
      <jw-button type="primary" size="small" v-if="from == 30 || (from == 20 && type == 30) || (type == 40 && subformPermission?.canEdit == 1 && subformPermission?.detail?.add == 1)" @click="formRef.handleSubmit(2)" :loading="data.loading">
        {{ $t('确定并添加一条') }}
      </jw-button>
      <jw-button type="primary" size="small" @click="formRef.handleSubmit()">{{ $t('确定') }}</jw-button>
    </template>
  </jw-drawer>
</template>

<script setup lang="jsx">
import { reactive, computed, ref, nextTick, watch } from 'vue';
import { Message } from '@arco-design/web-vue';
import { cloneDeep } from 'lodash';
import { tools } from '@/utils/tools';
import fieldDefaultVal from '@/hooks/default-value';
import fieldPermission from '@/hooks/field-permission';
import useViewFields from '@/hooks/view-fields'; //默认值相关的hooks
import { useI18n } from 'vue-i18n';
import { publicService } from '@/api';
import useFields from '@/hooks/fields';
const { getNewDefVal } = fieldDefaultVal();
const { isShowField, isEditableField } = fieldPermission();
const { rules } = useViewFields();
const { t } = useI18n();
import FhFromTableTitle from '@/components/fh-add-edit/components/fh-from-table-title/fh-from-table-title.vue';
const props = defineProps({
  modulesItem: {
    //规则过滤后的表格的字段信息
    type: Object,
    default: () => {
      return {};
    }
  },
  dataList: {
    type: Array,
    default: () => []
  },
  permission: {
    type: Object,
    default: () => {}
  },
  permissionBak: {
    type: Object,
    default: () => {}
  },
  disabledAll: {
    type: Boolean,
    default: false
  },
  isFull: {
    type: Boolean,
    default: false
  },
  from: {
    type: [Number, String],
    default: ''
  },
  type: {
    type: [Number, String],
    default: ''
  },
  mainForm: {
    type: Array,
    default: () => []
  },
  entity: {
    type: [Number, String],
    default: ''
  }
});
const emits = defineEmits(['cb', 'updateDataList']);
const formRef = ref();
const { fieldIconMapping } = useFields();
watch(
  () => props.permission,
  () => {
    const dl = cloneDeep(props.dataList);
    let isCallBack = false; //是否需要因为业务规则变更重新生成数据
    const _fieldPermissions = {};
    props.modulesItem?.modules?.forEach((pmm) => {
      _fieldPermissions[pmm?.setting?.fieldKey] = {
        display: pmm?.display,
        isRequired: pmm?.isRequired,
        businessData: pmm?.businessData
      };
    });
    dl?.forEach((dlc) => {
      dlc?.forEach((item) => {
        const _fieldKey = item?.setting?.fieldKey;
        if (_fieldPermissions?.[_fieldKey] !== undefined) {
          if (item.display != _fieldPermissions[_fieldKey].display) {
            isCallBack = true;
            item.display = _fieldPermissions[_fieldKey].display;
          }
          if (item.isRequired != _fieldPermissions[_fieldKey].isRequired) {
            isCallBack = true;
            item.isRequired = _fieldPermissions[_fieldKey].isRequired;
          }
          if (item.businessData != _fieldPermissions[_fieldKey].businessData) {
            isCallBack = true;
            item.businessData = _fieldPermissions[_fieldKey].businessData;
          }
        }
      });
    });
    if (isCallBack) {
      callbackData(dl);
      refreshTable();
    }
  },
  { deep: true }
);
const isHover = ref(false);
const setHover = (hover) => {
  isHover.value = hover;
};
//子表单权限
const subformPermission = computed(() => {
  return tools.isJSON(props.modulesItem?.permission) ? JSON.parse(props.modulesItem?.permission) : {};
});
const callbackData = (newDataList) => {
  // if (methods?.setSubformData) {
  //   methods?.setSubformData({
  //     id: props.modulesItem?.id,
  //     data: newDataList
  //   });
  // }
  console.log('updateDataList-c', newDataList);
  emits('updateDataList', {
    id: props.modulesItem?.id,
    data: newDataList
  });
};
//刷新表格
const tableKey = ref(tools.randomString(6));
const refreshTable = () => {
  tableKey.value = tools.randomString(6);
};
const getRowClass = ({ rowIndex }) => {
  return `custom-row-class-${props.modulesItem?.id}-${rowIndex}`;
};
const columns = computed(() => {
  const list = [
    {
      title: 'operation',
      colKey: 'operationCell',
      fixed: 'left',
      cell: 'operationCell',
      width: 80
    }
  ];
  props?.modulesItem?.modules?.forEach((item) => {
    //如果业务规则可见字段
    if (isShowField(`${props.modulesItem.value}.${item?.setting?.fieldKey}`, props.permission?.value, props.permissionBak?.[`${props.modulesItem.value}.${item?.setting?.fieldKey}`]?.display ?? 1)) {
      const colType = {
        title: (h, { col }) => <FhFromTableTitle col={col} fieldItem={item} />,
        colKey: item?.setting?.fieldKey,
        conditionsIsRequired: item?.conditionsIsRequired,
        width: item?.setting?.fieldName.length <= 5 ? 200 : item?.setting?.fieldName.length * 30,
        fieldName: item?.setting?.fieldName,
        isRequired: item?.setting?.isRequired,
        toast: item?.toast
      };

      list.push(colType);
    }
  });
  return list;
});
//业务规则是否可编辑
const isPermissionEdit = computed(() => {
  return isEditableField([props.modulesItem?.value, props.modulesItem?.id], props.permission?.value, props.permissionBak?.[props.modulesItem?.value]?.businessData ?? 1) && !props.disabledAll;
});
const data = reactive({
  checkedAllShow: false,
  selectIds: [],
  loading: false,
  recordIndex: null,
  form: {
    subForm: []
  }
});
const indeterminate = computed(() => {
  return props.dataList?.length > 0 && data.selectIds.length > 0 && data.selectIds.length < props.dataList.length;
});
const checked = computed(() => {
  return props.dataList?.length > 0 && data.selectIds.length == props.dataList.length;
});
const drawerVisible = ref(false);
// 操作(type==0:取消或者关闭编辑抽屉，type==1:打开编辑抽屉)
const toggleDrawerVisible = async (type, rowIndex = null) => {
  if (type == 1) {
    data.recordIndex = rowIndex;
  }

  drawerVisible.value = !drawerVisible.value;
};
//切换表单 type:1 左切 type:2 右切
const switchForm = (type) => {
  if (type == 1) {
    if (data.recordIndex < 1) {
      return;
    }
    data.recordIndex--;
  }
  if (type == 2) {
    if (data.recordIndex >= props.dataList?.length - 1) {
      return;
    }
    data.recordIndex++;
  }
};
// 全屏
const fullScreen = () => {
  emits('cb');
};

//切换删除显示状态
const toggleDeleteState = () => {
  data.checkedAllShow = !data.checkedAllShow;
  data.selectIds = [];
};

//单条删除
const del = (rowIndex) => {
  const dl = cloneDeep(props.dataList);
  dl.splice(rowIndex, 1);
  callbackData(dl);
};

// 更新子表字段默认值
const updateSubFieldModule = async (modules) => {
  if (props.from == 20 && props.type == 30) {
    //主表来源,新建，复制触发
    data.loading = true;
    const params = {
      entity: props.entity,
      formData: props.mainForm,
      subFormKey: props?.modulesItem?.setting?.fieldKey,
      modules: modules,
      init: false
    };
    await getNewDefVal(params, 2);
    data.loading = false;
  }
};
const addDetail = async () => {
  if (props.dataList?.length >= 300) {
    Message.warning('子表单数据最多添加300行！');
    return;
  }
  const modules = cloneDeep(props?.modulesItem?.modules);
  await updateSubFieldModule(modules);
  const dl = cloneDeep(props.dataList);
  dl.push(modules);
  callbackData(dl);
  setTbodyScrollTo();
};

// 批量操作 batchOp(1)复制到下一行,batchOp(2)复制到最后一行,batchOp(3)向上插入行,batchOp(4)向下插入行,
const batchOp = async (type, record, rowIndex) => {
  if (props.dataList?.length >= 300) {
    Message.warning('子表单数据最多添加300行！');
    return;
  }
  const modules = cloneDeep(props?.modulesItem?.modules); // 深拷贝原始数据
  const getRowIndexRecord = cloneDeep(record); // 深拷贝当前行的数据
  console.log(modules, 'console.log(modules');
  if ([3, 4].includes(type)) await updateSubFieldModule(modules);

  getRowIndexRecord?.map((r) => {
    r['detailId'] = ''; //唯一标识id
    r['businessData'] = '1'; //可编辑
    r['remove'] = 1; //可删除
  });
  modules?.map((r) => {
    r['detailId'] = ''; //唯一标识id
    r['businessData'] = '1'; //可编辑
    r['remove'] = 1; //可删除
  });
  const dl = cloneDeep(props.dataList);
  // 根据类型处理不同的操作
  switch (type) {
    case 1: // 复制到下一行
      dl.splice(rowIndex + 1, 0, getRowIndexRecord);
      break;
    case 2: // 复制到最后一行
      dl.push(getRowIndexRecord);
      break;
    case 3: // 向上插入行
      // 如果是第一行，则插入到开头
      if (rowIndex === 0) {
        dl.unshift(modules);
      } else {
        // 否则，插入到当前行的前面
        dl.splice(rowIndex, 0, modules);
      }
      break;
    case 4: // 向下插入行
      dl.splice(rowIndex + 1, 0, modules);
      break;
    default:
      console.error('Invalid operation type:', type);
  }
  callbackData(dl);
  const newRowIndex = type == 1 || type == 4 ? rowIndex + 1 : type == 2 ? dl.length : rowIndex;
  setTbodyScrollTo(newRowIndex);
};
// 是表格的body滚动到新添加的数据位置
const setTbodyScrollTo = (rowIndex = null) => {
  nextTick(() => {
    if (props.dataList?.length > 0) {
      const _rowIndex = rowIndex === null ? props.dataList?.length - 1 : rowIndex;
      const tableRowDom = document.querySelector(`.custom-row-class-${props.modulesItem?.id}-${_rowIndex}`);
      if (tableRowDom) {
        tableRowDom.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  });
};
// 表单提交 （操作(type==1:复制，type==2:确定并添加一条，type==3:确定并)）
const handleSubmit = async ({ values, errors }, type) => {
  if (!errors) {
    //文件未上传完给提示
    const incompleteFileList = [];
    props.dataList[data.recordIndex]?.forEach((item) => {
      if (item.type == 20 && item?.setting?.fieldType === 18) {
        if (item.fieldValue && item.filesList && item.fieldValue.length != item.filesList.length) {
          incompleteFileList.push(item.fieldValue);
        }
      }
    });

    if (incompleteFileList && incompleteFileList.length) {
      Message.warning(t('文件未上传完成,请稍后提交！'));
      return;
    }
    console.log(values);
    if (type == 1 || type == 2) {
      //1：复制  /:2：确定并添加一条
      if (props.dataList?.length >= 300) {
        Message.warning('子表单数据最多添加300行！');
        return;
      }
      const getRowIndexRecord = type == 1 ? cloneDeep(props.dataList[data.recordIndex]) : cloneDeep(props?.modulesItem?.modules); // 深拷贝当前行的数据

      if (type == 2) await updateSubFieldModule(getRowIndexRecord);

      getRowIndexRecord.map((r) => {
        r['detailId'] = ''; //唯一标识id
        r['businessData'] = '1';
        r['remove'] = 1; //可删除
      });
      const dl = cloneDeep(props.dataList);
      dl.push(getRowIndexRecord);
      callbackData(dl);
      data.recordIndex = props.dataList?.length - 1;
      nextTick(() => {
        setTbodyScrollTo(props.dataList.length);
      });
    } else {
      // 确定--关闭
      drawerVisible.value = false;
    }
  }
};
// 单条选中
const handleChange = (value) => {
  const pos = data.selectIds.indexOf(value);
  if (pos > -1) {
    data.selectIds.splice(pos, 1);
  } else {
    data.selectIds.push(value);
  }
};
//批量--全选
const handleChangeAll = (value) => {
  data.selectIds = [];
  if (value) {
    props.dataList?.forEach((item, index) => {
      data.selectIds.push(index);
    });
  }
};
//批量删除
const batchDel = () => {
  // 首先将索引排序，从大到小排列
  const sortedRowIndices = data.selectIds?.sort((a, b) => b - a);
  const dl = cloneDeep(props.dataList);
  sortedRowIndices?.forEach((rowIndex) => {
    // 确保索引在有效范围内
    if (rowIndex >= 0 && rowIndex < dl.length) {
      dl.splice(rowIndex, 1);
    }
  });
  callbackData(dl);
  data.selectIds = [];
  data.checkedAllShow = false;
};
const setDetailDataFieldValue = (cfm, _tmpData) => {
  const key = cfm?.setting?.fieldKey;
  const fieldType = cfm?.setting?.fieldType;
  const fieldExt = cfm?.setting?.fieldExt;
  let fieldValue = _tmpData[key];
  if (fieldType == 2 || fieldType == 4) {
    //2.单选 4.下拉单选
    fieldValue = _tmpData[key] || _tmpData[key] === 0 || _tmpData[key] === '0' ? _tmpData[key] : '';
  } else if (fieldType == 3 || fieldType == 5) {
    //3.多选 5.下拉多选
    fieldValue = _tmpData[key] ? _tmpData[key].split(',') : [];
  } else if (fieldType == 6) {
    //6.人员
    const _user = [];
    const _name = [];
    const _list = _tmpData[key] ? (Array.isArray(_tmpData[key]) ? _tmpData[key] : [_tmpData[key]]) : [];
    _list.forEach((v) => {
      _user.push({
        id: v.userId || v.id || '',
        userName: v.userName,
        avatarOrigin: v.avatar || v.avatarOrigin || ''
      });
      _name.push(v.userName);
    });
    cfm.setting['fv'] = {
      userList: _user,
      departList: []
    };
    fieldValue = _name;
  } else if (fieldType == 7) {
    //7.数字
    fieldValue = _tmpData[key] ? parseFloat(_tmpData[key]) : '';
  } else if (fieldType == 8) {
    //8.日期
    fieldValue = _tmpData[key];
  } else if (fieldType == 9) {
    //9.日期范围
    if (tools.isJSON(_tmpData[key]) && JSON.parse(_tmpData[key])?.beginDate && JSON.parse(_tmpData[key])?.endDate) {
      fieldValue = [JSON.parse(_tmpData[key])?.beginDate, JSON.parse(_tmpData[key])?.endDate];
    } else {
      fieldValue = null;
    }
  } else if (fieldType == 10) {
    //10.级联选择器
    fieldValue = _tmpData[key] ? _tmpData[key].split('/') : [];
  } else if (fieldType == 16) {
    //16.金额
    fieldValue = tools.getPrice(_tmpData[key], fieldExt ? fieldExt : 2);
  } else if (fieldType == 18) {
    //18.附件
    fieldValue = _tmpData[key] && tools.isJSON(_tmpData[key]) ? JSON.parse(_tmpData[key]) : [];
  } else if (fieldType == 22) {
    //22.部门
    const _depart = [];
    const _name = [];
    const _list = _tmpData[key] ? (Array.isArray(_tmpData[key]) ? _tmpData[key] : [_tmpData[key]]) : [];
    _list.forEach((v) => {
      _depart.push({
        id: v.departmentId || v.id || '',
        departmentName: v.departmentName || v.name || ''
      });
      _name.push(v.departmentName || v.name || '');
    });
    cfm.setting['fv'] = {
      departList: _depart,
      userList: []
    };
    fieldValue = _name;
  } else if (fieldType == 23) {
    //23.百分比
    fieldValue = tools.getPercentage(_tmpData[key], JSON.parse(fieldExt)?.numberFormat || 2);
  }
  return fieldValue;
};
// 查找关联单选赋值
const getAssociationAssign = async (modulesItem, rowIndex, eventType, dl) => {
  const params = {
    eventType: eventType, //0:新增 1：修改 2：清除
    layoutConfigId: modulesItem?.id, //当前字段的id
    fieldKey: modulesItem?.setting?.fieldKey,
    entity: modulesItem?.setting?.entityId,
    associateEntity: modulesItem?.setting?.fieldExt,
    associateId: modulesItem?.fieldValue,
    settingId: modulesItem?.setting?.id
  };
  const res = await publicService.getAssociationAssign(params);
  let isAssign = false;
  if (!res?.error && res?.result && Object?.keys(res.result).length > 0) {
    const _tmpData = res.result;
    dl[rowIndex].map((cfm) => {
      if (Object?.keys(_tmpData)?.includes(cfm?.setting?.fieldKey)) {
        cfm.fieldValue = setDetailDataFieldValue(cfm, _tmpData);
        isAssign = true;
      }
    });
  }

  return isAssign;
};
// 表格里编辑---字段子组件回调
const updateModulesItem = async (getformatData, modulesItem, rowIndex) => {
  const dl = cloneDeep(props.dataList);
  if (getformatData) {
    dl[rowIndex] = getformatData;
  } else {
    const _index = dl?.[rowIndex]?.findIndex((df) => df?.value === modulesItem?.value);
    if (_index > -1) {
      dl[rowIndex][_index] = cloneDeep(modulesItem);
    }
  }
  let isAssign = false;
  //字段类型为12 并且有值 并且有赋值规则
  if (modulesItem?.setting?.fieldType == 12 && modulesItem?.fieldValue && modulesItem?.fieldAssignment && modulesItem?.fieldAssignment?.entityFieldRuleEvent && modulesItem?.fieldAssignment?.fieldAssignmentRules?.length > 0) {
    isAssign = await getAssociationAssign(modulesItem, rowIndex, 0, dl);
  }
  callbackData(dl);
  //如果有赋值规则，表格更新
  if (isAssign) {
    refreshTable();
  }
};
// 抽屉里字段回调
const updateDrawerModulesItem = async (getformatData, modulesItem) => {
  await updateModulesItem(getformatData, modulesItem, data.recordIndex);
  if (modulesItem?.setting?.fieldType === 6 || modulesItem?.setting?.fieldType === 22) {
    //人员或部门
    data.form.subForm?.forEach((item, index) => {
      if (item.type == 20) {
        if (item?.setting?.fieldKey == modulesItem.value) {
          formRef.value?.clearValidate([`subForm.${index}.fieldValue`]);
        }
      }
    });
  }
};
</script>

<style scoped lang="less">
@import './fh-subform-content.less';
</style>
